import { render, staticRenderFns } from "./HomeExp.vue?vue&type=template&id=2dc8c483&scoped=true&"
import script from "./HomeExp.vue?vue&type=script&lang=js&"
export * from "./HomeExp.vue?vue&type=script&lang=js&"
import style0 from "./HomeExp.vue?vue&type=style&index=0&id=2dc8c483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8c483",
  null
  
)

export default component.exports